@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="vehDsbrd vehicle-slider-shell">
  <!-- First Section: Vehicle Card/Info and Map -->
  @if (userDtls?.rle_id!=4000001) {
  <section class="widget-card">
    <div class="vehicle-map-grid-container">
      <!-- Left Part: Vehicle Card (Top) and Vehicle Info (Bottom) - 1/3 width -->
      <!-- Vehicle Card (Top) -->
      <div class="vehicle-details-grid-column">
        <div>
          <h2><span>Vehicle</span></h2>
          <div class="veList">
            @if (VhcleDetails.crw_img_url && VhcleDetails.crw_img_url !=
            'undefined') {
            <div class="driver-photo">
              <img [src]="VhcleDetails.crw_img_url" alt="Driver" />
            </div>
            }
            <div class="info-row">
              <div class="info-label">
                <h3>Vehicle Registration Number</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value fw-600">
                <h4 class="value-emphasis">
                  {{ vehnm == null ? "NA" : vehnm }}
                  @if (VhcleDetails?.asrt_ownr_id == 1) {
                  <span
                    style="
                      margin-left: 6px;
                      padding: 2px 8px;
                      font-size: 10px;
                      font-weight: 600;
                      border-radius: 4px;
                      background-color: #dbeafe;
                      color: #1d4ed8;
                    "
                    >Own Vehicle</span
                  >
                  } @if (VhcleDetails?.asrt_ownr_id == 2) {
                  <span
                    style="
                      margin-left: 6px;
                      padding: 2px 8px;
                      font-size: 10px;
                      font-weight: 600;
                      border-radius: 4px;
                      background-color: #fef3c7;
                      color: #b45309;
                    "
                    >Hired Vehicle</span
                  >
                  }
                </h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Driver Name</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                @if (VhcleDetails) {
                <h4>
                  @if (VhcleDetails.crw_nm === null) {
                  <span>Driver not assigned</span>
                  } @if (VhcleDetails.crw_nm !== null) {
                  <span>
                    {{ VhcleDetails.crw_nm }}
                    @if (VhcleDetails.crw_own_in == 1) {
                    <span
                      style="
                        margin-left: 6px;
                        padding: 2px 8px;
                        font-size: 10px;
                        font-weight: 600;
                        border-radius: 4px;
                        background-color: #dbeafe;
                        color: #1d4ed8;
                      "
                      >Own Driver</span
                    >
                    } @if (VhcleDetails.crw_own_in == 2) {
                    <span
                      style="
                        margin-left: 6px;
                        padding: 2px 8px;
                        font-size: 10px;
                        font-weight: 600;
                        border-radius: 4px;
                        background-color: #fef3c7;
                        color: #b45309;
                      "
                      >Hired Driver</span
                    >
                    }
                  </span>
                  }
                </h4>
                }
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Driver Phone Number</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                @if (VhcleDetails) {
                <h4>
                  {{
                    VhcleDetails.crw_ph === null
                      ? "Driver not assigned"
                      : VhcleDetails.crw_ph
                  }}
                </h4>
                }
              </div>
            </div>
            <div class="info-row current-location-row">
              <div class="info-label">
                <h3>
                  Current Location
                  <span
                    >@if (VhcleDetails.lat && VhcleDetails.lng) {
                    <button
                      class="location-icon"
                      (click)="showOnMap()"
                      type="button"
                      aria-label="View on map"
                    >
                      <i nz-icon nzType="environment" nzTheme="outline"></i>
                    </button>
                    }</span
                  >
                </h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value location-data-wrapper">
                <span class="location-text">{{
                  VhcleDetails.curr_loc || "NA"
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Vehicle Info (Bottom) -->
        <div>
          <h2>
            <span>Vehicle Info</span><span>&nbsp;({{ currentFrmtDate }})</span>
          </h2>
          <div class="veList">
            <div class="info-row">
              <div class="info-label">
                <h3>Vehicle Status</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ asrt_sts_nm == null ? "NA" : asrt_sts_nm }}</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Distance Travelled</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ CrntDyDst == null ? "0" : CrntDyDst }} Kms</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Start Location</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ VhcleDetails.startFence || "NA" }}</h4>
              </div>
            </div>
            @if (clntDtls && clntDtls[0].clnt_id==7) {
            <div class="info-row">
              <div class="info-label">
                <h3>Sachivalayam</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                @if (VhcleDetails) {
                <h4>
                  {{
                    VhcleDetails.svm_nm == null
                      ? "Sachivalayam not
                        assigned"
                      : VhcleDetails.svm_nm
                  }}
                </h4>
                }
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Secratory</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                @if (VhcleDetails) {
                <h4>
                  {{
                    VhcleDetails.ss_nm == null
                      ? "Secratory not
                        assigned"
                      : VhcleDetails.ss_nm
                  }}
                  @if (VhcleDetails.ss_cntct) {
                  <span>
                    -
                    {{
                      VhcleDetails.ss_cntct == null ? "" : VhcleDetails.ss_cntct
                    }}
                  </span>
                  }
                </h4>
                }
              </div>
            </div>
            }
            <!-- <div class="row">
              <div class="col-lg-5 col-md-5">
                <h3>Bins Covered</h3>
              </div>
              <div class="col-lg-1 col-md-1 w2">:</div>
              <div class="col-lg-5 col-md-5">
                <h4><b>{{totCvrsBns == null ? 0: totCvrsBns}}</b>/<b>{{totBins == null ? 0: totBins}}</b></h4> -->
            <!-- <h4><b *ngIf="totCvrsBns">{{totCvrsBns}}</b><b *ngIf="!totCvrsBns">0</b>/<b *ngIf="totBins">{{totBins}}</b><b *ngIf="!totBins">0</b></h4> -->
            <!-- </div>
            </div> -->
            <!-- <div class="row">
            <div class="col-lg-5 col-md-5">
              <h3>Fuel Issued</h3>
            </div>
            <div class="col-lg-1 col-md-1 w2">:</div>
            <div class="col-lg-5 col-md-5">
              <h4>{{CrntDyFuel == null ? 0: CrntDyFuel}} Ltrs | {{CrntDyFlAmt == null ? 0: CrntDyFlAmt}}
              Rs</h4>
            </div>
          </div> -->
            <!-- <div class="row">
          <div class="col-lg-5 col-md-5">
            <h3>Current Location</h3>
          </div>
          <div class="col-lg-1 col-md-1 w2">:</div>
          <div class="col-lg-5 col-md-5">
            <h4 *ngIf="vehRts && vehRts.length>0">{{vehRts[0].crnt_lctn_nm == null ? "NA": vehRts[0].crnt_lctn_nm}}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-5 col-md-5">
            <h3>Current Area</h3>
          </div>
          <div class="col-lg-1 col-md-1 w2">:</div>
          <div class="col-lg-5 col-md-5">
            <h4 *ngIf="vehRts && vehRts.length>0">{{vehRts[0].crnt_area_nm == null ? "NA": vehRts[0].crnt_area_nm}}</h4>
          </div>
        </div> -->
            <!-- <div class="info-row">
        <div class="info-label">
          <h3>Vehicle Odometer Reading</h3>
        </div>
        <div class="info-separator">:</div>
        <div class="info-value">
          <h4>{{vehOdmtr == null ? 0: vehOdmtr}} km</h4>
        </div>
      </div> -->
            <div class="info-row">
              <div class="info-label">
                <h3>Device Odometer Reading</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ devOdmtr == null ? 0 : devOdmtr }} km</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>IMEI Number</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ imei == null ? "" : imei }}</h4>
              </div>
            </div>
            <!-- <div class="info-row">
      <div class="info-label">
        <h3>Chasis Number</h3>
      </div>
      <div class="info-separator">:</div>
      <div class="info-value">
        <h4>{{chasis == null ? 'Not provided': chasis}}</h4>
      </div>
    </div> -->
            <div class="info-row">
              <div class="info-label">
                <h3>Speed</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ speed == null ? 0 : speed }} km/Hr</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Coverage%</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>
                  {{
                    VhcleDetails.coverage_per === null
                      ? 0
                      : VhcleDetails.coverage_per
                  }}
                  %
                </h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Departure Time</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>
                  {{
                    VhcleDetails.hme_fnce_out_ts === null
                      ? "NA"
                      : VhcleDetails.hme_fnce_out_ts
                  }}
                </h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Data Last Received on</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ data_lst_rcvd == null ? "" : data_lst_rcvd }}</h4>
              </div>
            </div>
            <!-- <div class="row">
    <div class="col-lg-5 col-md-5">
      <h3>Distance Travelled Today</h3>
    </div>
    <div class="col-lg-1 col-md-1 w2">:</div>
    <div class="col-lg-5 col-md-5">
      <h4>{{dst_tvl_tdy === null ? '0': dst_tvl_tdy}}</h4>
    </div>
  </div> -->
            <!-- <div class="row">
  <div class="col-lg-5 col-md-5">
    <h3>Stoppage Time</h3>
  </div>
  <div class="col-lg-1 col-md-1 w2">:</div>
  <div class="col-lg-5 col-md-5">
    <h4 *ngIf="diffTimeInMin < 60"><span>&nbsp;{{diffTimeInMin}} </span><span>Min</span></h4>
    <h4 *ngIf="diffTimeInMin >= 60 && diffTimeInHrs < 24"><span>&nbsp;{{diffTimeInHrs}}
      </span><span>Hrs</span></h4>
      <h4 *ngIf="diffTimeInMin >= 24 && diffTimeInDys > 0"><span>&nbsp;{{diffTimeInDys}}
        </span><span>Days</span></h4>
      </div>
    </div> -->
            <div class="info-row">
              <div class="info-label">
                <h3>Stoppages</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4
                  class="link-value"
                  [ngClass]="{ hgltCls: VhcleDetails.stps_morethn_five > 0 }"
                  (click)="showStoppages()"
                >
                  {{
                    VhcleDetails.stps_morethn_five === null
                      ? "0"
                      : VhcleDetails.stps_morethn_five
                  }}
                </h4>
              </div>
            </div>
            @if (vehRts && vehRts.length>0 && vehRts[0].frnt_cmra_url) {
            <div class="info-row camera-row">
              <div class="info-label">
                <h3>Front Camera</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <a
                  target="_blank"
                  [href]="vehRts[0].frnt_cmra_url"
                  class="camera-link"
                >
                  <i
                    nz-icon
                    nzType="camera"
                    nzTheme="outline"
                    class="icnHvr"
                  ></i>
                  <span>Open Feed</span>
                </a>
              </div>
            </div>
            } @if (vehRts && vehRts.length>0 && vehRts[0].bck_cmra_url) {
            <div class="info-row camera-row">
              <div class="info-label">
                <h3>Rear Camera</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <a
                  target="_blank"
                  [href]="vehRts[0].bck_cmra_url"
                  class="camera-link"
                >
                  <i nz-icon nzType="camera" nzTheme="outline" class="icnHvr">
                  </i>
                  <span>Open Feed</span>
                </a>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <!-- Map Column (Right Part) - 2/3 width -->
      <div class="map-grid-column">
        <!-- <h2><span>Map</span></h2> -->
        <div class="row" style="margin: 0">
          <div class="col-lg-12 col-md-12">
            <div class="row" style="margin-bottom: 10px">
              <label
                nz-checkbox
                [(ngModel)]="shwCrntLoc"
                (ngModelChange)="onChkCurrentLocation($event)"
                >Current Location</label
              >
              <label
                nz-checkbox
                [(ngModel)]="shwplyback"
                (ngModelChange)="onChkPlyback($event)"
                >Playback</label
              >
            </div>
          </div>
          <div class="col-lg-12 col-md-12">
            @if (!shwCrntLoc) {
            <div>
              <div class="mapdslctnDtls">
                <div class="travelruts">
                  <div class="grenbx"></div>
                  <div class="redbxlbl">Schedule Route</div>
                </div>
                <div class="scheduleruts">
                  <div class="redbx"></div>
                  <div class="redbxlbl">Travelled Route</div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        <div id="vehicleMap"></div>
      </div>
    </div>
  </section>
  <section class="widget-card">
    <div class="card-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5"
          style="color: #6366f1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
          ></path>
        </svg>
        <h3>24/7 Distance Coverage</h3>
      </div>
      <span class="badge">Last 7 Days</span>
    </div>
    <div class="card-body">
      <div id="hepachartdiv"></div>
    </div>
  </section>
  <!-- Charts Section: Two graphs in a row -->
  <section class="charts-grid">
    <div class="widget-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #8b5cf6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
            ></path>
          </svg>
          <h3>Distance Travelled</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        <div id="lastSevenDaysDistanceChart"></div>
      </div>
    </div>
    <div class="widget-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #10b981"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
          <h3>Trips Travelled</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (!chart2Msg) {
        <div id="lastSevenDaysChart"></div>
        } @if (chart2Msg) {
        <div class="empty-state">
          <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
          <p>{{ chart2Msg }}</p>
        </div>
        }
      </div>
    </div>
  </section>
  <!-- ---------------------------------------------------------------------------------------- -->
  <!-- Tables Section: Trips + Operational Details side by side -->
  <section class="tables-grid">
    <div class="widget-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
          <h3>Trips Coverage Of Vehicle</h3>
        </div>
        <span class="badge">Trips</span>
      </div>
      <div class="card-body">
        @if (tripsData && tripsData.length>0) {
        <div class="cstm_tbl-wrapper">
          <table class="cstm_tbl">
            <thead>
              <tr>
                <th>sno</th>
                <th>ULB</th>
                @if (clntDtls[0]?.clnt_id==3000001) {
                <th>Zone</th>
                }
                <th>Vehicle</th>
                <th>Trip Number</th>
                <th>Source</th>
                <th>Destination</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Travelled Distance (In KM)</th>
                <th>Trip Status</th>
                <th>Route Deviated</th>
                <th>Playback</th>
              </tr>
            </thead>
            <tbody>
              @for (t of tripsData; track t) {
              <tr>
                <td>{{ t.sno }}</td>
                <td>{{ t.ZONE }}</td>
                @if (clntDtls[0]?.clnt_id==3000001) {
                <td>{{ t.asrt_grp_nm }}</td>
                }
                <td>{{ t.VEHICLE }}</td>
                <td>{{ t.TRIP_NUM }}</td>
                <td>{{ t.SOURCE }}</td>
                <td>{{ t.DESTINATION }}</td>
                <td>{{ t.ACTUAL_START }}</td>
                <td>{{ t.ACTUAL_END }}</td>
                <td>{{ t.actl_trvl_dstne_ct }}</td>
                <td>{{ t.TripStatus }}</td>
                <td>{{ t.Deviation }}</td>
                <td
                  (click)="goToPlayback(t)"
                  style="color: #009688; cursor: pointer"
                >
                  <i nz-icon nzType="node-index" nzTheme="outline"></i> Playback
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (tripsData && tripsData.length == 0) {
        <div class="empty-state">
          <i nz-icon nzType="car" nzTheme="outline"></i>
          <p>No trips found for this vehicle</p>
        </div>
        }
      </div>
    </div>
    <div class="widget-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #6366f1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            ></path>
          </svg>
          <h3>Operational Details</h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (oprtnlhrs && oprtnlhrs.length>0) {
        <div class="cstm_tbl-wrapper">
          <table class="cstm_tbl">
            <thead>
              <tr>
                <th>Date</th>
                <th>Vehicle No.</th>
                <th>Vehicle Category</th>
                <th>Operational Hours</th>
                <th>Travelled(km)</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (o of oprtnlhrs; track o) {
              <tr>
                <td>{{ o.dt }}</td>
                <td>{{ o.asrt_nm }}</td>
                <td>{{ o.asrt_ctgry_nm }}</td>
                <td>{{ o.oprtn_hrs_ct }}</td>
                <td>{{ o.dst }}</td>
                @if (o.operated == 1) {
                <td style="color: #009688">Operated</td>
                } @if (o.operated == 0) {
                <td style="color: #9c27b0">Not-Operated</td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (oprtnlhrsMsg) {
        <div class="empty-state">
          <i nz-icon nzType="file-text" nzTheme="outline"></i>
          <p>{{ oprtnlhrsMsg }}</p>
        </div>
        }
      </div>
    </div>
  </section>
  <!-- Speed Violations + Trips List side by side -->
  <section class="tables-grid">
    <div class="widget-card">
      <div class="card-header warning">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #f59e0b"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            ></path>
          </svg>
          <h3>Speed Violations</h3>
        </div>
        <span class="badge warning">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (ovrSpeed && ovrSpeed.length>0) {
        <div class="cstm_tbl-wrapper">
          <table class="cstm_tbl">
            <thead>
              <tr>
                <th>Recorded Date</th>
                <th>Vehicle No.</th>
                <th>Vehicle Category</th>
                <th>Speed(km)</th>
                <th>Track Vehicle</th>
              </tr>
            </thead>
            <tbody>
              @for (t of ovrSpeed; track t) {
              <tr>
                <td>{{ t.dt }}</td>
                <td>{{ t.asrt_nm }}</td>
                <td>{{ t.asrt_ctgry_nm }}</td>
                <td>{{ t.speed }}</td>
                <td>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query={{
                      t.r_lat
                    }},{{ t.r_lng }}"
                    target="_blank"
                    ><i nz-icon nzType="node-index" nzTheme="outline"></i
                    >Track</a
                  >
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (ovrSpeedMsg) {
        <div class="empty-state">
          <i nz-icon nzType="safety-certificate" nzTheme="outline"></i>
          <p>{{ ovrSpeedMsg }}</p>
        </div>
        }
      </div>
    </div>
    <div class="widget-card">
      <div class="card-header">
        <div class="flex items-center gap-2">
          <svg
            class="w-5 h-5"
            style="color: #8b5cf6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 10h16M4 14h16M4 18h16"
            ></path>
          </svg>
          <h3>
            Trips List @if (eachVeh && eachVeh.length) {
            <b>{{ VhcleDetails.asrt_nm }}</b>
            }
          </h3>
        </div>
        <span class="badge">Last 7 Days</span>
      </div>
      <div class="card-body">
        @if (eachVeh && eachVeh.length>0) {
        <div class="cstm_tbl-wrapper">
          <table class="cstm_tbl">
            <thead>
              <tr>
                <th>Date</th>
                <th>No. of Trips</th>
                <th>Driver</th>
                <th>Travelled(km)</th>
              </tr>
            </thead>
            <tbody>
              @for (o of eachVeh; track o) {
              <tr>
                <td>{{ o.dt }}-{{ curYr }}</td>
                <td>{{ o.trp_cnt }}</td>
                <td>{{ o.crw_nm ? o.crw_nm : "Driver not Assigned" }}</td>
                <td>{{ o.trp_dst }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @if (tripsMsg) {
        <div class="empty-state">
          <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
          <p>{{ tripsMsg }}</p>
        </div>
        }
      </div>
    </div>
  </section>
  <!-- ---------------------------------------------------------------------------------------- -->
  <!-- <div class="bg-wp"  *ngIf="vehTrpLst && vehTrpLst.length>0">
        <h1 style="padding: 15px 20px 0px 15px;
        text-align: left;">Vehicle Trip Details</h1>
<div class="row">
  <div class="col-lg-4 col-md-4 htscrl" *ngIf="!vehTrpLstMsg>0">
    <div class="serchCard" *ngFor="let c of vehTrpLst">
      <div class="row">
        <div class="col-lg-11 col-md-11">
          <div class="row serchCardPdng" style="padding-top:5px ;">
            <div class="col-lg-7 col-md-7 col">
              <p class="serchCardLeftTxt srchCrdHdr">{{c.asrt_nm}}</p>
                                    <p class="serchCardLeftTxt srchCrdHdr" style="    font-size: 12px;
                                    font-weight: 500;
                                    line-height: 8px;
                                    color: #3f51b5;">{{c.asrt_ctgry_nm}}</p>
            </div>
            <div class="col-lg-5 col-md-5 col mg-a">
              <p class="serchCardLeftTxt srchCrdHdr" style="text-align: right;">Trip -
              {{c.trp_sqnc_nu}}</p>
                                    <p class="serchCardLeftTxt srchCrdHdr" style="text-align: right;    font-size: 12px;
                                    font-weight: 500;
                                    line-height: 8px;
                                    color: #3f51b5;">{{c.trip_sts}}</p>
            </div>
          </div>
          <div class="row serchCardPdng" style="padding-top:6px ;">
            <div class="col-lg-2 col-md-2 col">
              <p class="serchCardLeftTxt">From</p>
            </div>
            <div class="col-lg-1 col-md-1 col">
              <p class="serchCardRightTxt" style="text-align: center;">:</p>
            </div>
            <div class="col-lg-9 col-md-9 col">
              <p class="serchCardRightTxt">{{c.strt_fnce_nm}}</p>
                                    <p class="serchCardRightTxt" style="text-align: left;
                                    font-size: 12px;
                                    line-height: 8px;">{{c.start_tm}}</p>
            </div>
          </div>
          <div class="row serchCardPdng" style="padding-top:6px ;">
            <div class="col-lg-2 col-md-2 col">
              <p class="serchCardLeftTxt">To</p>
            </div>
            <div class="col-lg-1 col-md-1 col">
              <p class="serchCardRightTxt" style="text-align: center;">:</p>
            </div>
            <div class="col-lg-9 col-md-9 col">
              <p class="serchCardRightTxt">{{c.end_fnce_nm}}</p>
                                    <p class="serchCardLeftTxt" style="text-align: left;
                                    font-size: 12px;
                                    line-height: 8px;">{{c.end_tm}}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-1 col-md-1" style="margin: auto;padding: 0px;">
          <p class="serchCardLeftTxt" style=" font-size: 15px;text-align: center; margin: auto;"
            (click)="getTripMap(c,slctdDt)">
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4 col-md-4 htscrl" *ngIf="vehTrpLstMsg">
    <div class="row NtfctnCrd">
      <h5 style="text-align: center;">{{vehTrpLstMsg}}</h5>
    </div>
  </div>
  <div class="col-lg-8 col-md-8"  style="width: 100%;height: 600px;overflow: hidden;">
    <img src="assets/images/logo/map.png">
  </div>
</div>
</div> -->
  }
</div>
<nz-modal
  [(nzVisible)]="shwStpgWndw"
  nzTitle="Stoppage Details"
  (nzOnCancel)="closeStpgSideBar()"
  (nzOnOk)="handleOk()"
  nzWidth="800px"
  nzClassName="prkngdtls"
>
  <ng-container *nzModalContent>
    <app-data-grid
      id="grid"
      class="gridHeight"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="stpgData"
      [legacyColumns]="stpgcolumnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="Parking points List"
      [pageSize]="10"
      [allowedPageSizes]="[10, 30, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="false"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <!-- [width]="f.field == 'sno' ?80:200" -->

      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons_edit"
        [width]="100"
        caption="Location"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="cursor-pointer tblEdtBtn" (click)="vewonMap(data.data)">
            Map View
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </ng-container>
</nz-modal>
